import { consumer, Delay, Execute, inject, SequenceChain, Sound } from "@spawn/core";
import { GoldenBonusService } from "@spawn/golden-bonus";
import {
	dimBackgroundEvent,
	showSymbolsOnSpotlight,
	SymbolMetaDataKeys,
	TeaserBellModule,
	WinSignState,
} from "@spawn/slot-machine";

@consumer
export class NrgTeaserBellModule extends TeaserBellModule {
	@inject protected readonly goldenBonusService!: GoldenBonusService;

	public override async start(): Promise<void> {
		const normalCoordinates = this.partyService.paylineWins.flatMap((payline) => payline.symbolCoordinates);
		const bonusCoordinates = this.goldenBonusService.getBonusSymbols().map((bonus) => bonus.position);

		// Highlight all winning symbols, also the bonus symbols.
		this.eventDispatcher.dispatch(
			showSymbolsOnSpotlight({
				symbolCoordinates: [...normalCoordinates, ...bonusCoordinates],
				symbolMetaDataKeys: this.spotlightMetaDataKeys(),
			})
		);
		await this.chain.play();
	}

	protected spotlightMetaDataKeys(): string[] {
		return [SymbolMetaDataKeys.BaseTexture];
	}

	public override init(): void {
		const [niceMin] = this.partyService.winFactorRanges[WinSignState.Nice];
		this.chain = new SequenceChain(
			...(this.partyService.winFactor >= niceMin
				? [
						new Execute(() => {
							this.eventDispatcher.dispatch(dimBackgroundEvent(this.backgroundDimValue(), this.backgroundDimDuration()));

							if (!this.sound) {
								this.sound = new Sound(this.winSoundService.teaserBellSound(), true);
							}

							// FDM-161: stop ambient sound when teaser bell starts playing
							this.ambientSoundController.fadeOutSound();

							void this.sound.play();
						}),
						new Delay(this.teaserBellDuration()),
					]
				: [])
		);
	}
}
